<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal classifieds-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">New Classified</h4>
                </div>
                <div class="modal-body">
                    <div class="classified-edit-toolbar">
                        <div (click)="changeStyle('font_size', 'font_big')" class="_uppercase"></div>
                        <div (click)="changeStyle('font_size', 'font_sm')" class="_lowercase"></div>
                        <div (click)="changeStyle('text', 'text_left')" class="_align-left"></div>
                        <div (click)="changeStyle('text', 'text_center')" class="_align-center"></div>
                        <div (click)="changeStyle('text', 'text_right')" class="_align-right"></div>
                        <div (click)="changeStyle('text', 'text_just')" class="_align-justify"></div>
                    </div>
                    <div class="classified">
                        <div class="title-textarea">
                            <textarea required class="classified-note-sticker-field" placeholder="Title"
                                      (focus)="focusedItem='modelTitle'" name="modelTitle" [(ngModel)]="model.title"></textarea>
                        </div>
                        <div class="content-textarea" >
                            <textarea required class="classified-note-sticker-field" placeholder="Content"
                                      (focus)="focusedItem='modelContent'" name="modelContent" [(ngModel)]="model.content"></textarea>
                        </div>
                        <div class="item-owner">
                            <div class="_phone">
                                <input class="classified-note-sticker-field" required type="text" placeholder="Phone"
                                       (focus)="focusedItem=''" name="modelPhone" [(ngModel)]="model.phone">
                            </div>
                            <div class="_name">
                                <input class="classified-note-sticker-field" required type="text" placeholder="Name"
                                       (focus)="focusedItem=''" name="modelName" [(ngModel)]="model.name">
                            </div>
                        </div>
                    </div>
                    <div class="details">
                        <div class="row m-b-sm inlineDateAndTime inline-date-time-classifieds">
                            <div class="col-md-2">
                                <label>Start</label>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="startDate" name="startDate"
                                           (focus)="startDatePicker.open()" (click)="startDatePicker.open()"
                                           [matDatepicker]="startDatePicker" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <label>Expiry</label>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="expiryDate" [min]="startDate" name="expiryDate"
                                           (focus)="expiryDatePicker.open()" (click)="expiryDatePicker.open()"
                                           [matDatepicker]="expiryDatePicker" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="expiryDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #expiryDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- ___ Playlist ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-2">
                                <label>Playlist</label>
                            </div>
                            <div class="col-md-10 fourteenPixelText">
                                <select class="form-control" name="playlistId" [ngModel]="data.playlistId" required
                                        (change)="changePlaylist($event.target.value)" #playlistSelect
                                        [disabled]="playlistSelectIsDisabled">
                                    <option value="" hidden></option>
                                    <!--<option *ngFor="let build of keyLogService.buildings" [value]="build.id">{{build.name}}</option>-->
                                </select>
                            </div>
                        </div>
                        <div class="row text-center space-30">
                            <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds-modal/classifieds-modal.component.html